import { render, staticRenderFns } from "./OtherDocument.vue?vue&type=template&id=33c25326&scoped=true"
import script from "./OtherDocument.vue?vue&type=script&lang=js"
export * from "./OtherDocument.vue?vue&type=script&lang=js"
import style0 from "./OtherDocument.vue?vue&type=style&index=0&id=33c25326&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33c25326",
  null
  
)

export default component.exports